// Sticky menu for history timeline

document.addEventListener("DOMContentLoaded", () => {


    // Timeline 
    // Sticky classes for navigation bar
    const stickyNav = document.querySelector('[data-sticky-menu]');

    if(stickyNav){

        var observer = new IntersectionObserver(function(entries) {
            // no intersection with screen
            if(entries[0].intersectionRatio === 0)
                document.querySelector('.app').classList.add('sticky-active');
            // fully intersects with screen
            else if(entries[0].intersectionRatio === 1)
                document.querySelector('.app').classList.remove('sticky-active');
        }, { threshold: [0,1] });
        
        observer.observe(document.querySelector('.sticky-top'));

    //     const topNav = document.querySelector('#site-header');
    //     const navTop = stickyNav.offsetTop - topNav.offsetHeight;
    //     const navStickyHeight = stickyNav.offsetHeight;
    //     console.log(stickyNav.offsetTop);
    //     function stickyNavigation() {
    //     // scrolled past the sticky nav - stick it
    //     if (window.scrollY >= navTop) {
    //         document.body.style.paddingTop = navStickyHeight + "px";
    //         document.body.classList.add('fixed-nav');
    //     } else {
    //         document.body.style.paddingTop = 0 + "px";
    //         document.body.classList.remove('fixed-nav');
    //     }
    //     }
    //     window.addEventListener('scroll', stickyNavigation);
    }

    // Sticky navigation active links
    const sections = document.querySelectorAll('[data-scroll-view]');
    // const links = document.querySelectorAll('.timeline-nav__link');
    
    window.addEventListener('scroll', navHighlighter);
    function navHighlighter() {
        let scrollY = window.pageYOffset;
        var totalMenuHeight = stickyNav.offsetHeight + 120;
        
        sections.forEach(current => {
            const sectionHeight = current.offsetHeight;
            const sectionTop = current.offsetTop - totalMenuHeight;
            var sectionId = current.getAttribute('id');
            if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                var activeMenu = document.getElementById('scroll-to-' + sectionId);
                if (activeMenu) {
                    // links.forEach(function(link) {
                    //     link.classList.remove('active');
                    // });
                    document.getElementById(activeMenu.id).classList.add('active');
                }
            } 
            else {
                var activeMenu = document.getElementById('scroll-to-' + sectionId);
                if (activeMenu) {
                    document.getElementById(activeMenu.id).classList.remove('active');
                }
            }
        });
    }
})